import ICustomMessagingState, { ICustomMessagingMessage, ICustomMessagingTag } from "./customMessaging.state";
import { CustomMessagingAction } from "./customMessaging.actions";
import CustomMessagingTypes from "./customMessaging.types";

const defaultState : ICustomMessagingState = {
    customMessageLoading: false,
    singleMessageLoading: "",
    tagsLoading: false,
    customMessages: undefined,
    customMessagingTags: undefined
}


const removeExistingTags = (CustomMessages: ICustomMessagingMessage[] | undefined, tags: ICustomMessagingTag[] | undefined) => {
    if (!tags || !CustomMessages) return [];
    const tagsIds = tags.map(t => t.key);
    return CustomMessages.map(m => {
        const tags = m.tags.filter(t => !tagsIds.includes(t.key));
        return {...m, tags}
    })
}

export default function (state = defaultState, action: CustomMessagingAction): ICustomMessagingState {
    switch (action.type) {
        case CustomMessagingTypes.CUSTOM_MESSAGING_MESSAGES_LOADING:
            return {
                ...state,
                customMessageLoading: action.payload ?? true
            }
        case CustomMessagingTypes.GET_CUSTOM_MESSAGING_MESSAGES:
            return {
                ...state,
                customMessages: action.payload,
                customMessageLoading: false
            }
        case CustomMessagingTypes.EDIT_CUSTOM_MESSAGING_MESSAGE:
            return {
                ...state,
                customMessageLoading: false,
                customMessages: removeExistingTags(state.customMessages, action.payload.tags).map(message => {
                    if (action.payload?.id === message.id) {
                        return {...message, ...action.payload};
                    }
                    return message;
                }) ?? [],
                singleMessageLoading: ""
            }
        case CustomMessagingTypes.DELETE_CUSTOM_MESSAGING_MESSAGE:
            return {
                ...state,
                customMessageLoading: false,
                customMessages: state.customMessages?.filter(message => message.id !== action.payload) ?? [],
                singleMessageLoading: ""
            };
        case CustomMessagingTypes.ADD_CUSTOM_MESSAGING_MESSAGE:
            return {
                ...state,
                customMessageLoading: false,
                customMessages: state.customMessages ? [...removeExistingTags(state.customMessages, action.payload.tags), action.payload] : [action.payload],
                singleMessageLoading: ""
            }
        case CustomMessagingTypes.CUSTOM_MESSAGING_TAGS_LOADING:
            return {
                ...state,
                tagsLoading: true
            }
        case CustomMessagingTypes.CUSTOM_MESSAGING_SINGLE_MESSAGE_LOADING:
            return {
                ...state,
                singleMessageLoading: action.payload
            }
        case CustomMessagingTypes.GET_CUSTOM_MESSAGING_TAGS:
            return {
                ...state,
                customMessagingTags: action.payload,
                tagsLoading: false,
            }
    
        default:
            return state;
    }
}